export default track => ({
    click(name) {
        track('Program', 'Klik', name)
    },

    register(name) {
        track('Program', 'Daftar', name)
    },

    confirmed(name) {
        track('Program', 'Konfirmasi', name)
    }
})
